// extracted by mini-css-extract-plugin
module.exports = {"holder":"OneOrg_holder__4l7js","panels":"OneOrg_panels__3IA39","stats":"OneOrg_stats__3ULE-","boxes":"OneOrg_boxes__3aecz"};